import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: Ceylon",
  "description": "",
  "published": "2012-09-27T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-ceylon/swizec/5328"],
  "categories": "Ceylon, Functional programming, Java, JavaScript, Object-oriented programming, Red Hat, Scala, Uncategorized",
  "hero": "./img/ceylon-ceylon-lang.org-master-images-ceylon_homebanner_elephant.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://ceylon-lang.org/"
      }}>{`Ceylon`}</a>{` is an exciting new programming language, and by new I mean it appeared in 2011 and I heard about it last week. But it `}<em parentName="p">{`is`}</em>{` new enough that no official version has yet been released.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ceylon"
      }}>{`void hello() {

    print("Hello, World!");

}
`}</code></pre>
    <p>{`The brain child of `}<a parentName="p" {...{
        "href": "http://www.redhat.com",
        "title": "Red Hat"
      }}>{`Red Hat`}</a>{`, Ceylon promises to be `}{`_`}{`"a language for writing large programs in teams", `}{`_`}{`its striking design goal being code clearly readable even by people who aren't Ceylon programmers.`}</p>
    <p>{`I haven't had a chance to play with it, but all the code samples are very readable. So far so good!`}</p>
    <p>{`In short, Ceylon is a static typed `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Object-oriented_programming",
        "title": "Object-oriented programming"
      }}>{`object oriented language`}</a>{` that runs on `}<strong parentName="p">{`Java`}</strong>{` and `}<strong parentName="p">{`JavaScript`}</strong>{` virtual machines and introduces many interesting features from `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Functional_programming",
        "title": "Functional programming"
      }}>{`functional programming languages`}</a>{` such as Scala.`}</p>
    <p>{`That's right kids, it runs in a browser.`}</p>
    <h2 {...{
      "id": "whys-it-cool"
    }}>{`Why's it cool?`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "370px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/2a4cfbee1df810fbea1689f3a129252c/1efb2/ceylon-ceylon-lang.org-master-images-ceylon_homebanner_elephant.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "69.95515695067265%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'280\\'%20viewBox=\\'0%200%20400%20280\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M326%2022c-6%203-9%2013-7%2024%202%2013%207%2024%2018%2035%2011%2013%2018%2023%2018%2029%200%2015-17%2012-22-4-8-29-20-53-27-55s-38%200-61%203c-12%202-20%203-35%203-47%200-107%2010-144%2024-7%203-11%207-19%2026-8%2018-22%2062-20%2064l11-10c15-15%2015-15%2015%203%202%2043%209%2086%2016%20103l1%204h35l1-3c0-4%203-4%203%200v3h36l-1-4a500%20500%200%2000-4-32c-1-14-2-17-5-17l1-1h7l15%201c12%201%2012%201%2015%2012a391%20391%200%200010%2034l2%207h21l21-1%202-9%202-6%201-1h1c2%202%204%2011%204%2015v2h45v-2c-6-18-10-37-12-56-5-28-8-40-10-38a880%20880%200%20000-12c1-3%207-9%2011-10%205-3%208-2%2023%204%2016%206%2026%208%2038%208%2036%200%2056-18%2053-48-2-16-7-25-19-36-23-21-27-26-27-36V32c-4%200-7-3-9-7l-2-4-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2a4cfbee1df810fbea1689f3a129252c/ca0a1/ceylon-ceylon-lang.org-master-images-ceylon_homebanner_elephant.webp 223w", "/static/2a4cfbee1df810fbea1689f3a129252c/9e982/ceylon-ceylon-lang.org-master-images-ceylon_homebanner_elephant.webp 370w"],
                "sizes": "(max-width: 370px) 100vw, 370px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2a4cfbee1df810fbea1689f3a129252c/e92b6/ceylon-ceylon-lang.org-master-images-ceylon_homebanner_elephant.png 223w", "/static/2a4cfbee1df810fbea1689f3a129252c/1efb2/ceylon-ceylon-lang.org-master-images-ceylon_homebanner_elephant.png 370w"],
                "sizes": "(max-width: 370px) 100vw, 370px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2a4cfbee1df810fbea1689f3a129252c/1efb2/ceylon-ceylon-lang.org-master-images-ceylon_homebanner_elephant.png",
                "alt": "Ceylon",
                "title": "Ceylon",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Ceylon`}</figcaption>{`
  `}</figure></p>
    <p>{`Leaving aside for a moment it compiles to two different intermediate codes (java bytecode and javascript) and just how astoundingly `}<em parentName="p">{`awesome`}</em>{` that is, I also have a soft spot for anything JavaScript.`}</p>
    <p>{`Really, though, the most striking feature is `}<strong parentName="p">{`Ceylon's `}<a parentName="strong" {...{
          "href": "http://en.wikipedia.org/wiki/Type_system",
          "title": "Type system"
        }}>{`type system`}</a></strong>{`.`}</p>
    <p>{`First of all, there are no `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Primitive_data_type",
        "title": "Primitive data type"
      }}>{`primitive types`}</a>{`, everything is magically pulled out of thin air by something called `}<em parentName="p">{`principal typing.`}</em>{` Apparently that means it can understand how types work straight from their descriptions, rather than relying on some arcane knowledge.`}</p>
    <blockquote>
      <p parentName="blockquote">{`For every expression, a unique, most specific type may be determined, without the need to analyze the rest of the expression in which it appears. And all types used internally by the compiler are `}<em parentName="p">{`denotable`}</em>{` - that is, they can be expressed within the language itself.`}</p>
    </blockquote>
    <p>{`Even better than that, whatever `}<em parentName="p">{`that`}</em>{` actually is, are union and intersection types.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ceylon"
      }}>{`Person|Organization personOrOrganization = ... ;

Printable&Sized&Persistent printableSizedPersistent = ... ;
`}</code></pre>
    <p>{`You can essentially tell the compiler some value will be either a `}<em parentName="p">{`string`}</em>{` or an `}<em parentName="p">{`integer`}</em>{` or even both and it won't even bat an eyelid. Add a sprinkling of local type inference and you get something very powerful indeed.`}</p>
    <p>{`A thing can have `}<em parentName="p">{`two+`}</em>{` types. Strictly typed.`}</p>
    <p>{`Let that sink in for a bit.`}</p>
    <p>{`Now think how useful this can be when you want to have a list of items that will be of different types. Yep, pretty awesome.`}</p>
    <p>{`There's also `}<strong parentName="p">{`typesafe null and `}{`<`}{`stuff>`}</strong>{`, known to readers of this blog as `}<em parentName="p"><a parentName="em" {...{
          "href": "http://swizec.com/blog/monads-monads-monads-monads/swizec/5206",
          "title": "Monads, monads, monads, monads"
        }}>{`That thing Swizec can't for the life of him understand`}</a>{`.`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-ceylon"
      }}>{`String? name = ...

String|Nothing name = ...
`}</code></pre>
    <p>{`This ensures we don't get any strange `}<em parentName="p">{`NullPointerExceptions`}</em>{` when we least want them and is essentially the same as Haskell's Maybe monad thingy. Useful stuff :)`}</p>
    <p>{`Another magnificent idea are `}<strong parentName="p">{`polymorphic attributes`}</strong>{`.`}</p>
    <p>{`Rather than objects having fields in the traditional sense, they have attributes. Attributes which can be pretty much anything from a simple value, to a getter-setter combination without being forced to manually define these things.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ceylon"
      }}>{`# simple value
String name = firstName + " " + lastName;

# getter setter pair
String name {
    return fullName;
}

assign name {
    fullName := name;
}
`}</code></pre>
    <p>{`More importantly, the state of the class is completely abstracted away from whomever uses the class. Let it deal with itself.`}</p>
    <h2 {...{
      "id": "other-things"
    }}>{`Other things`}</h2>
    <p>{`Those are the three features that struck out when I looked through the `}<a parentName="p" {...{
        "href": "http://ceylon-lang.org/documentation/current/introduction/"
      }}>{`Quick Introduction`}</a>{`.`}</p>
    <p>{`But there's also a bunch of stuff we've come to expect from any modern language like higher order functions, comprehensions, a simple way to define tree-like structures ... The latter most likely being much more powerful than I currently understand.`}</p>
    <p>{`Most importantly, it's not a moving target like Scala! They have milestones and after a milestone is reached they are promising no API's and syntax and whatnot are going to change until the next milestone comes out. Very important if you ever put things in production.`}</p>
    <p>{`Can't wait to find an excuse to play with Ceylon.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.javacodegeeks.com/2012/09/is-java-dead-or-invincible.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_2_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.javacodegeeks.com/2012/09/is-java-dead-or-invincible.html"
        }}>{`Is Java Dead or Invincible?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://architects.dzone.com/articles/should-your-static-go-static"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_77_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://architects.dzone.com/articles/should-your-static-go-static"
        }}>{`Should Your Startup Go with Static or Dynamic Languages?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.adobe.com/webplatform/2012/08/27/javascript-types/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_105_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blogs.adobe.com/webplatform/2012/08/27/javascript-types/"
        }}>{`JavaScript: Types`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://englishtea.us/2012/08/16/ceylon-black-tea/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/107082342_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://englishtea.us/2012/08/16/ceylon-black-tea/"
        }}>{`Ceylon Black Tea`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://slidetocode.com/2012/09/26/clojures-place-in-the-jvm/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_54_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://slidetocode.com/2012/09/26/clojures-place-in-the-jvm/"
        }}>{`How Clojure is to the JVM as Bash scripts are to Unix`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5de5fd7f-88ce-4913-a43b-02d4f5a4083e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      